import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { DealerServiceFilterModel } from 'projects/Widget/src/app/business-entities/dealer-service-filter-model';
import { Subscription } from 'rxjs';
import { ServiceViewModel } from '../../../business-entities/service-view-model';
import { Features } from '../../../business-entities/user-role-view-model';
import { ServicesService } from '../../../business-services/services.service';
import { PartNumberModel, PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { PartsBusinessService } from '../../../business-services/parts.service';


@Component({
  selector: 'app-search-service',
  templateUrl: './search-service.component.html'
})
export class SearchServiceComponent implements OnInit {
  isViewSearch: boolean = false;
  serviceSearchTerm: string = '';
  SearchedServices: ServiceViewModel[] = [];
  services: ServiceViewModel[] = [];
  currentlagSub: Subscription;
  dealerServiceFilterModel: DealerServiceFilterModel;
  serviceCategories: any[] = [];
  @Input() selectedServiceIdArray: any;
  isWarningLightFeature: boolean = false;
  features: Features[] = [];
  partsList: PartsListViewModel[] = [];
  partModel: PartNumberModel;
  constructor(private activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cookieservice: CookieService,
    private service: ServicesService,
    private spinner: NgxSpinnerService,
    private secureStorage: SecureStorage,
    private partService: PartsBusinessService,
  ) { }

  ngOnInit(): void {
    this.features = this.secureStorage.getKeyData('feature');
    if (!isNullOrUndefined(this.features) && this.features.length > 0) {
      if (this.features.find(x => x.featureCode === Enums.FeatureCode.WarningLight))
        this.isWarningLightFeature = this.features.find(x => x.featureCode === Enums.FeatureCode.WarningLight)?.isActive;
    }

    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.SearchedServices = [];
    this.serviceSearchTerm = '';
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.GetServicesByDealerId();
    });
    if (this.service.searchService) {
      this.serviceSearchTerm = this.service.searchService;
      this.GetSearchedServices();
    }

  }

  ngOnDestroy(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
  }
  OnClose() {
    this.activeModal.dismiss(false);
  }
  GetServicesByDealerId() {
    let language = this.cookieservice.get('userSelectedLanguage')
    let dateFormatRegistrationDate = Utility.getDateStringToDate(this.service.registrationDate);
    let date = new Date();
    let vehicleAge = Utility.monthDiff(dateFormatRegistrationDate, date);
    this.dealerServiceFilterModel = {
      fuelType: this.service.engineTypeCode,
      vehicleType: this.service.vehicleTypeCode,
      brand: this.service.companyMakeCode,
      model: this.service.model,
      language: language,
      mileage: this.service.previousKilometer,
      vehicleAge: vehicleAge,
      dealerId: this.service.dealerId,
      customerNo: this.service.customerNo
    }
    this.spinner.show();
    this.serviceCategories = [];

    this.service.GetServicesByDealerId(this.dealerServiceFilterModel).then(result => {
      if (result.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.serviceCategories = result.responseObject;
        if (this.serviceCategories?.length > 0) {
          this.serviceCategories.forEach(x => {
            x.clicked = false;
            // to push child service for display
            x.services.forEach(service => {
              if (service.childServiceId) {
                let childServiceIdArray = service.childServiceId.split(',');
                service.displaychildServiceDetail = []
                childServiceIdArray.forEach(childserviceId => {
                  this.serviceCategories.forEach(category => {
                    category.services.forEach(servicelist => {
                      if (servicelist.serviceId === parseInt(childserviceId)) {
                        service.displaychildServiceDetail.push(servicelist)
                      }
                    });
                  });
                });
              }
              if (service.isWarningLight && this.isWarningLightFeature) {
                service.warningLightService?.forEach(element => {
                  element.isSelected = false;
                });

              }
            });
          });
          this.serviceCategories[0].clicked = true;
        }
        this.onServiceCategorySelection(this.serviceCategories[0].service, this.serviceCategories[0].id)

      }
      else {
        this.spinner.hide();
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  GetSearchedServices() {
    this.SearchedServices = [];
    this.isViewSearch = true;
    if (this.serviceSearchTerm != null && this.serviceSearchTerm != '' && this.serviceSearchTerm != undefined) {
      this.serviceCategories.forEach(x => {
        let list = x.services.filter(y => y.name?.toLowerCase().includes(this.serviceSearchTerm?.toLowerCase()) || y.serviceNo == this.serviceSearchTerm || y.aFxPackageNo == this.serviceSearchTerm);
        if (list?.length > 0) {
          list.forEach(element => {
            // element.isDisable = this.selectedServiceIdArray?.includes(element.id);
            this.SearchedServices.push(element);
          })
        }
      })
    }
    else {
      let ServiceNotFound = this.translate.instant("lblNoServicesFound")
      this.toastr.error(ServiceNotFound);
    }
  }
  onServiceCategorySelection(_serviceCategoryName, serviceCategoryId) {
    this.isViewSearch = false;
    if (this.serviceCategories?.length > 0) {
      this.serviceCategories.forEach(x => {
        x.clicked = false;
        if (x.id == serviceCategoryId) {
          x.clicked = true;
        }
      });
    }
    let category = this.serviceCategories.filter(x => x.id === serviceCategoryId);
    this.services = category[0].services;
    //selectedServiceId is dealer service Id & this.services[0].Id is dealer service Id
    this.services.forEach(element => {
      // let isDisable = this.selectedServiceIdArray?.includes(element.id);
      // element.isDisable = isDisable;
      element.isServiceChecked = false;
    });
  }
  onServiceSearch() {
    this.isViewSearch = !this.isViewSearch;
    if (this.serviceCategories?.length > 0) {
      this.serviceCategories.forEach(x => {
        x.clicked = false;
      });
    }
  }
  onServiceSelected(service, isSelected: boolean, event) {
    //add to servicelist to display in html
    service.isServiceChecked = !isSelected;
    if (service.isServiceChecked) {
      //for set isServiceChecked true to the service selected
      this.serviceCategories.forEach(element => {
        element.services.forEach(subElement => {
          if (subElement.isWarningLight && this.isWarningLightFeature) {
            service.warningLightService?.forEach(element => {
              element.isSelected = false;
            });

          }
          if (subElement.serviceId === parseInt(service.serviceId)) {
            subElement.isServiceChecked = true;
          }
        });
      });
      //for child service
    }
    else {
      //if parent unselect the remove child service
      let childServiceId = [];
      //remove from display
      if (service.displaychildServiceDetail && service.displaychildServiceDetail.length > 0) {
        service.displaychildServiceDetail.forEach(element => {
          childServiceId.push(element.serviceId);
          element.addedAsChildService = false;
          element.isServiceChecked = false;
        });
      }
      if (childServiceId.length > 0) {
        childServiceId.forEach(childService => {
          this.serviceCategories.forEach(element => {
            element.services.forEach(subElement => {
              if (subElement.serviceId === parseInt(childService)) {
                subElement.isServiceChecked = false;
              }
            });
          });
        });
      }
    }
  }
  stopEvent(event:Event){
    event.stopPropagation();
  }
  stopEventOfChildService (event:Event,childservice){
    childservice.isServiceChecked =  !childservice.isServiceChecked;
    event.stopPropagation();
  }
  UpdateDisplayChildService(service) {
    this.SearchedServices.forEach(element => {
      element.displaychildServiceDetail?.forEach(subelement => {
        if (subelement?.name == service.Name) {
          subelement.isServiceChecked = true;
          subelement.addedAsChildService = true;
          subelement.parentServiceName = service.parentServiceName;
        }
      });
    })
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async onSaveService() {
    this.service.SelectedServices = [];
    this.serviceCategories.forEach(element => {
      let mappedService = element.services.filter(x => x.isServiceChecked)
      if (mappedService.length > 0) {
        mappedService.forEach(element => {
          this.service.SelectedServices.push(element);
        });
      }
    });

    if (this.service.SelectedServices.length == 0) {
      let ServiceNotFound = "Please select at least one service.";
      this.toastr.error(ServiceNotFound);
      return;
    }
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    this.spinner.show();
    //Get selected service Package link BOM
    await Promise.all(this.service.SelectedServices.map(async (e) => {
      if (!this.empty(e.aFxPackageNo)) {
        this.partsList = [];
        this.partService.partNumberModel = [];

        e.servicePackageBOM.forEach(s => {
          if (s.bomTypeId == 2) {
            this.partModel = { partNumber: s.no };
            this.partService.partNumberModel.push(this.partModel);
          }
        });
        //if part found in service package then get latest part quantity.
        if (this.partService.partNumberModel.length > 0) {

          let model = {
            locationCode: this.service.locationCode,
            partNumberModel: this.partService.partNumberModel,
            languageCode: languageCode
          }
          await this.partService.GetPartDetails(model).then(response => {

            this.partsList = response;
            if (this.partsList && this.partsList?.length > 0) {
              e.servicePackageBOM.forEach(element => {
                if (element.bomTypeId == 2) {
                  let part = this.partsList.find(x => x.partNumber == element.no);
                  element.unitPrice = part.unitPrice;
                  element.totalQuantityOnLocal = part.quantity;
                  element.availableQuantity = part.availableQuantity;
                  element.centralTotalQty = part.centralTotalQty;
                  element.centralAvailableQty = part.centralAvailableQty;
                }
              });
            }
          });
        }
      }
    }));

    this.spinner.hide();
    this.activeModal.dismiss(true);
  }
}
